export default {"src":"/_next/static/media/tta_2.18497b35.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};